import React from "react";
import { assets } from "../../../Assets/assets";

const Partners = () => {
  const partnerImgs = [
    assets.partnerlogo1,
    assets.partnerlogo2,
    assets.partnerlogo3,
    assets.partnerlogo4,
    assets.partnerlogo5,
    assets.partnerlogo6,
  ];

  return (
    <section className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14">
      <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-x-10 gap-y-10 justify-items-center items-center">

        <div data-aos="fade-up-right" data-aos-duration="1000" className="text-center md:text-left">
          <div
            className="text-[120px] md:text-[15rem] font-bold leading-none bg-cover bg-center text-transparent bg-clip-text"
            style={{
              backgroundImage: `url(${assets.numberbg})`,
            }}
          >
            50
          </div>

          <p className="text-primaryNavyTextColor text-lg md:text-3xl font-semibold mt-2">
            Partners Worldwide
          </p>
        </div>

        <div data-aos="fade-up-left" data-aos-duration="1000" className="border rounded-xl col-span-2 p-6 grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {partnerImgs.map((logo, index) => (
            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100}
              key={index}
              className="flex items-center justify-center border border-gray-200 rounded-md p-4 hover:bg-gray-50 transition-all duration-300"
            >
              <img
                src={logo}
                alt="Partner Logo"
                className="w-24 md:w-28 object-contain opacity-80 hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
